import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';
import { Formik } from 'formik';
import { string, object } from 'yup';
import { FormGroup } from '../forms/FormBootstrap';
import { validaCnpj, validaCpf } from './Validacoes';

class CadastroDocumentos extends Component {
    constructor(props) {
        super(props);
        this.validationSchema = object().shape({
            juridica: string()
                .required()
                .oneOf(["true", "false"]),
            docFazenda: string()
                .label('CPF/CNPJ')
                .ensure()
                .required('Campo obrigatório')
                .transform((value, originalValue) => {
                    return originalValue.replace(/[^0-9]/gi, "");
                })
                .when('juridica', {
                    is: "true",
                    then: string()
                        .test("cnpjvalido", "CNPJ inválido", (value) => {
                            return validaCnpj(value);
                        })
                        .test('ja-existe', 'Este CNPJ já está cadastrado', async (value) => {
                            var texto = await (await fetch('cadastro/jaexistedoc?doc=' + value)).json();
                            return texto === false;
                        }),
                    otherwise: string()
                        .test("cpfvalido", "CPF inválido", (value) => {
                            return validaCpf(value);
                        })
                        .test('ja-existe', 'Este CPF já está cadastrado', async (value) => {
                            var texto = await (await fetch('cadastro/jaexistedoc?doc=' + value)).json();
                            return texto === false;
                        })
                }),
            nome: string()
                .label('Nome ou Razão Social')
                .required('Campo obrigatório'),
            nomeFantasia: string()
                .label('Nome Fantasia')
                .when('juridica', {
                    is: "true",
                    then: string().required("Campo obrigatório")
                }),
            responsavel: string()
                .label('Responsável')
                .when('juridica', {
                    is: "true",
                    then: string().required("Campo obrigatório")
                })
        });

    }

    onSubmit(values, actions) {
        if (this.props.onSubmit) {
            this.props.onSubmit(values, actions);
        } else {
            console.log("No onSubmit prop");
        }
    }

    render() {
        return <Formik
            onSubmit={(values, actions) => { this.onSubmit(values, actions) }}
            initialValues={{
                juridica: 'true',
                docFazenda: '',
                nome: '',
                nomeFantasia: '',
                responsavel: ''
            }}
            validateOnBlur={true}
            validateOnChange={true}
            validationSchema={this.validationSchema}
            render={(props) => {
                const {
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                } = props;

                return (
                    <form onSubmit={handleSubmit}>

                        <div className="row">
                            <FormGroup errors={errors} touched={touched} campo="juridica">
                                <div className="radio">
                                    <label><input id="juridica" type="radio" name="juridica" value={true} defaultChecked onChange={handleChange} onBlur={handleBlur} />Pessoa jurídica</label>
                                    <label><input id="pessoaFisica" type="radio" name="juridica" value={false} onChange={handleChange} onBlur={handleBlur} />Pessoa física </label>
                                </div>
                            </FormGroup>
                        </div>
                        <div className="row">
                            <FormGroup errors={errors} touched={touched} campo="docFazenda">
                                <label htmlFor="docFazenda" id="lbDocFazenda" data-balloon-pos="right">{values.juridica === "true" ? "CNPJ" : "CPF"}</label>
                                <MaskedInput
                                    className="form-control"
                                    name="docFazenda"
                                    placeholder="00.000.000/0000-00"
                                    mask={
                                        values.juridica === "true"
                                            ? [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
                                            : [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.docFazenda}
                                />
                            </FormGroup>
                        </div>
                        <div className="row">
                            <FormGroup errors={errors} touched={touched} campo="nome">
                                <label htmlFor="nome" id="lbNome" data-balloon-pos="right">{values.juridica === "true" ? "Razão social" : "Nome completo"}</label>
                                <input type="text" className="form-control" id="nome" name="nome" aria-describedby="help-nome" value={values.nome} onChange={handleChange} onBlur={handleBlur} />
                            </FormGroup>
                        </div>
                        {values.juridica === "true" &&
                            <React.Fragment>
                                <div className="row">
                                    <FormGroup errors={errors} touched={touched} campo="nomeFantasia">
                                        <label htmlFor="nomeFantasia" id="lbNomeFantasia">Nome fantasia</label>
                                        <input type="text" className="form-control" id="nomeFantasia" name="nomeFantasia"
                                            placeholder="Exemplo: Reis Net" aria-describedby="help-nomeFantasia" value={values.nomeFantasia} onChange={handleChange} onBlur={handleBlur} />
                                    </FormGroup>
                                </div>
                                <div className="row">
                                    <FormGroup errors={errors} touched={touched} campo="responsavel">
                                        <label htmlFor="responsavel" id="lbResponsavel">Pessoa responsável</label>
                                        <input type="text" className="form-control" id="responsavel" name="responsavel"
                                            placeholder="Exemplo: Nelson da Silva Reis" aria-describedby="help-responsavel" value={values.responsavel} onChange={handleChange} onBlur={handleBlur} />
                                    </FormGroup>
                                </div>
                            </React.Fragment>
                        }
                        <div className="row">
                            <div className="form-group col-sm-6 col-sm-offset-3">
                                <button type="submit" className="btn btn-success pull-right">Avançar &gt;</button>
                            </div>
                        </div>
                    </form>
                );
            }
            } />
    }
}

export default CadastroDocumentos;